import ROLES from "../../../Roles.json";

export default {
  canConfigureWayfinding: (state) => state.roleKey === ROLES.OpsAdmin,
}